import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PublicHeaderComponent } from './public-header.component';
import { PublicFooterComponent } from './public-footer.component';

@Component({
    selector: 'app-public-layout',
    standalone: true,
    imports: [RouterModule, PublicHeaderComponent, PublicFooterComponent],
    template: `
        <div class="bg-surface-50 dark:bg-surface-950 min-h-screen w-screen flex flex-col">
            <app-public-header />
            <main class="flex-1">
                <router-outlet />
            </main>
            <app-public-footer />
        </div>
    `
})
export class PublicLayout {}
